import React from 'react';
import Img from 'gatsby-image';
import CustomImage from '../custom-image';

const LeftImageRightText = ({ children, image, alt }) => {
  return (
    <div className="left-text-right-img">
      <div className="left">
        <CustomImage imageName={image} alt={alt} maxWidth="75" />
      </div>
      <div className="right">{children}</div>
    </div>
  );
};

export default LeftImageRightText;
